import "./deleted-alertcases.scss";
import { IColumn } from "../../components/data-table/data-table";
import DataTable from "../../components/data-table/data-table";
import Page from "../../components/page/page";

const columns: IColumn[] = [
  {
    key: "alertcase_id",
    displayName: "Alertcase ID",
    dataType: {
      type: "text",
    },
  },
  {
    key: "creation_date",
    displayName: "Creation Date",
    dataType: {
      type: "dateTime",
    },
  },
  {
    key: "deletion_date",
    displayName: "Deletion Date",
    dataType: {
      type: "dateTime",
    },
  }
];

const DeletedAlertcases = () => {
  return (
    <div className="deletedAlertcases">
      <Page
        title={{
          text: "Deleted alertcases",
          tooltip: "List of deleted alertcases that are older than the configured year",
        }}
      >
        <div className="deletedAlertcases-table">
          <DataTable
            defaultSortCol="deletion_date"
            columns={columns}
            dataUrl={
              {
                url: "deleted_alertcases",
                backend: "manager"
              }
            }
            selectionMode="off"
          />
        </div>
      </Page>
    </div>);
};

export default DeletedAlertcases;